import { memo, useCallback } from "react"
import Button from "../../../../../components/Button"
import { useTranslation } from "react-i18next"
import { getMobileProfile } from "../../../../../services/calls/mobiles"
import { useSidebar } from "../../../../../hooks/useSidebar"
import MobileProfile from "./MobileProfile"

type MobileDetailCol = {
  mobileid: number
}

const MobileDetailCol = memo(({ mobileid }: MobileDetailCol) => {
  const { t } = useTranslation()
  const { updateInfobar } = useSidebar()

  const openInfoSidebar = useCallback(async () => {
    const details = await getMobileProfile(mobileid)
    if (details) {
      updateInfobar({
        isOpen: true,
        clickOutsideClose: true,
        header: (
          <div className="Sidebar__header-label">
            {`${t('Car details for')}: `}<strong>{details.automobile.registration_number}</strong>
          </div>
        ),
        content: <MobileProfile data={details} />
      })
    }
  }, [mobileid])

  return (
    <Button
      type="tertiary"
      size="s"
      label={t('Details')}
      onClick={() => openInfoSidebar()}
    />
  )
})

export default MobileDetailCol
